import React, {useState, useContext} from "react";
import "./QuestionView.css";
import CheckIcon from '../image/CheckIcon';

import Modal from '../UI/Modal';
import ModalContext from '../store/ModalContext';

const QuestionView = ({
    Questions, 
    currentQuestion, 
    handleQuestionSelectClick, 
    handleNextLevelRequest, 
    progressBar, 
    questionLength, 
    typenschild,
    nextQuestionStatus,
    modalAction,
    modalWaitForAction,
    appLocation
}) => {
    const questionHeadline =  "Frage " + (currentQuestion + 1) + " / " + questionLength;
    const [questionData, setQuestionData] = useState('');
    const [typenschildInput, setTypenschildInput] = useState('');
    const [textareaStatus, setTextareaStatus] = useState(false);
    const [modelTextStatus, setModalTextStatus] = useState(false);

    const modalCtx = useContext(ModalContext);



    const locationAktive = () => {
        if(appLocation){
            switch(appLocation){
                case ("Dachgauben"):
                    return "Holzbau/ Zimmerei/ Dachgaube";
                break;
                case("Flachdach"):
                    return "Flachdach oder Garagendach";
                break;
                case("Dachfenster"):
                    return "Dachfenster";
                break;
                case("Dachreparaturen"):
                    return "Dachreparatur/ Wartung";
                break;
                case("Dachumdeckungen-Dachsanierung"):
                    return "Dachdecken/ Dachsanierung";
                break;
                case("Dachdeckerei"):
                    return "Dachdecken/ Dachsanierung";
                break;
                case("Garagenabdichtung"):
                    return "Flachdach oder Garagendach";
                break;
            }

        }
    }

    const handleInputChange = (e) => {
        setQuestionData(e.target.value);
    
        if(e.target.value.length >= 2){
            setTextareaStatus(true);
        }else{
            setTextareaStatus(false);
        }        
    }

    const handleInputTypenschildChange = (e) => {
        setTypenschildInput(e.target.value)
    }

    const modalStatusAction = (x) => {
        setModalTextStatus(x);
    }

    const resetModalStatusAction = () => {
        setModalTextStatus(false);
    }

    const dachsanierungAction = () => {
        handleQuestionSelectClick('Dachdecken/ Dachsanierung');
    }

    return(
        <>
            <Modal open={modalCtx.showModal}>
                {modelTextStatus == 'Layout1' ? 
                    <div>
                        <h2>Hinweis zum Zeitraum:</h2>
                        <p>Es tut uns leid, aber in dem von Ihnen angegeben Zeitraum sind wir ausgebucht</p>
                        <button onClick={() => {modalWaitForAction(false, modalCtx.closeModal);resetModalStatusAction()}} className="refuse">Ok</button>
                    </div>
                : modelTextStatus == 'Layout2' ?
                    <div>
                        <h2>Für PV-Anlage nicht geeignet:</h2>
                        <p>Leider ist Ihr Dach für eine PV-Anlage nicht geeignet, hier geht es zur Dachsanierung.</p>
                        <button onClick={() => {modalWaitForAction(false, modalCtx.closeModal);resetModalStatusAction();dachsanierungAction()}} className="refuse">Dachsanierung</button>
                    </div>   
                :
                    <div>
                        <h2>Hinweis zum Angebot:</h2>
                        <p>Das Erstellen eines Angebotes wird mit einer Kostennote von <b>80,00 Euro</b> berechnet.
                         Dieser Betrag wird Ihnen bei einer späteren Auftragserteilung erstattet. Vor jeder Angebotsausarbeitung nehmen wir immer persönlich mit Ihnen Kontakt auf.</p>
                        <button onClick={() => {modalWaitForAction(false, modalCtx.closeModal);resetModalStatusAction()}} className="refuse">Ablehnen</button>
                        <button onClick={() => {modalWaitForAction(true, modalCtx.closeModal);resetModalStatusAction()}} className="agree">Ok</button>
                    </div>
                }
            </Modal>

            <div className="question">
                <div className="question-number">
                    <span>
                        {questionLength !== 1 && questionHeadline}                      
                    </span>
                    <br></br>
                    {progressBar !== 0 && <progress value={progressBar} />}
                </div>
                <div className="question-text">
                    {Questions[currentQuestion].question} 
                </div>
            </div>
            <div className="answer">
                {Questions[currentQuestion].answers.map(({id, title, textarea, request, text, nextQuestions, modal}) => (
                    title ? (
                        <div key={id} className={`answer-item ${title == locationAktive() && 'answer-active'}` } >
                        {id == 0 ? 
                            <button onClick={() => {
                                request || nextQuestions ? handleNextLevelRequest(title, request, nextQuestions) : handleQuestionSelectClick(title, modal); modalAction(title, modal, modalCtx.showModal); modalStatusAction('Layout1');
                            }}>
                            {title} 
                            </button>
                            : (id == 53) ?
                            <button onClick={() => {
                                request || nextQuestions ? handleNextLevelRequest(title, request, nextQuestions) : handleQuestionSelectClick(title, modal); modalAction(title, modal, modalCtx.showModal); modalStatusAction('Layout2');
                            }}>
                            {title} 
                            </button>
                            : 
                            <button onClick={() => {
                                request || nextQuestions ? handleNextLevelRequest(title, request, nextQuestions) : handleQuestionSelectClick(title, modal); modalAction(title, modal, modalCtx.showModal);
                            }}>
                            {title} 
                            </button>
                        }

                        {
                            nextQuestionStatus ? (
                                nextQuestions ? (
                                    nextQuestions.map(({id, question, answers}) => (
                                        <div key={id} className="answer-item-children">
                                            <label>{question}</label>
                                            {answers.map(({id, title})=>(
                                                <div key={id} className={title ? "answer-item-children-input-handler" : "answer-item-children-textarea-handler"}>
                                                    {
                                                        title ? (
                                                            <div className="answer-item-input">
                                                                <button onClick={() => {handleQuestionSelectClick(title)}}>
                                                                    {title}
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div className="question-check answer-item-textarea">
                                                                <label>{textarea}</label>
                                                                <textarea placeholder={"Hier bitte eintragen..."} onChange={handleInputChange}></textarea>
                                                                {textareaStatus ? 
                                                                <span className="textarea-checker" onClick={() => handleQuestionSelectClick(questionData)}>
                                                                    Weiter
                                                                    <i>
                                                                        <CheckIcon/>
                                                                    </i>
                                                                </span>
                                                                : 
                                                                null}
                                                            </div>    
                                                        )
                                                    }
                                                </div>
                                            ))}
                                        </div>
                                       ))
                                ) : (
                                    null
                                )
                            ) : (null)
                        }
                        {typenschild ?  
                            (
                                <div key={id} className="typenschild-wrap">
                                    {request ? (
                                        <div className="typenschild-inner">
                                            <p>{request.title}</p><hr></hr>
                                            <div className="typenschild-handler">
                                                <input type="text" placeholder="Typenschilder" onChange={handleInputTypenschildChange}/>
                                                <i onClick={() => handleQuestionSelectClick(typenschildInput)}>
                                                    <CheckIcon/>
                                                </i>
                                            </div>
                                        </div>
                                    ): null}
                                </div>
                            )
                        : 
                            null
                        }
                       </div>
                    )
                    : (
                        text ? (
                            <div key={id} className="question-check">
                                <input type="text" id="text" className="text" name="text"
                                    value={questionData.length > 1 ? questionData : questionData}
                                    placeholder={text}
                                    onChange={handleInputChange}
                                />
                                {
                                questionData && 
                                    <i onClick={() => handleQuestionSelectClick(questionData)}>
                                        <CheckIcon/>
                                    </i>
                                }
                        </div>     
                        ):(
                            <div key={id} className="question-check">
                                <label>{textarea}</label>
                                <textarea onChange={handleInputChange}></textarea>
                                {textareaStatus ? 
                                <span className="textarea-checker" onClick={() => handleQuestionSelectClick(questionData)}>
                                    Weiter
                                    <i>
                                        <CheckIcon/>
                                    </i>
                                </span>
                                : null}
                            </div>     
                        )
                    )
                ))}
            </div>
        </>
    );
};

export default QuestionView;